import { addBackToTop } from 'vanilla-back-to-top';
import './back_to_top.scss';

const DEFAULT_SETTINGS = {
  backgroundColor: '#555555',
  scrollDuration: 500,
  diameter: 51,
  showWhenScrollTopIs: 250,
};

export {
  addBackToTop,
  DEFAULT_SETTINGS,
};
